import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { http } from "@/lib/api";

export const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    let tries = 0;
    let stop = false;
    const poll = async () => {
      try {
        const r = await http.get(`/payments/status/${sessionId}`);
        if (stop) return;
        if (r.data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(r.data.status)) return setState("failed");
      } catch (e) { if (e?.response?.status === 404) { if (!stop) setState("failed"); return; } }
      if (stop) return;
      if (++tries < 15 && !stop) setTimeout(poll, 2000); else setState((s) => (s === "checking" ? "timeout" : s));
    };
    if (sessionId) poll(); else setState("failed");
    return () => { stop = true; };
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-success-page" data-state={state}>
      {state === "checking" && <><Loader2 className="w-10 h-10 mx-auto animate-spin text-[#6B9080]" /><p className="font-display text-2xl text-[#2C4A3E] mt-4">Confirming your payment…</p></>}
      {state === "paid" && <><CheckCircle2 className="w-12 h-12 mx-auto text-[#6B9080]" /><p className="font-display text-3xl text-[#2C4A3E] mt-4" data-testid="payment-paid">Welcome to ConsciousLearn</p><p className="text-stone-500 mt-2">Your subscription is active.</p></>}
      {(state === "failed" || state === "timeout") && <><XCircle className="w-12 h-12 mx-auto text-[#C87D53]" /><p className="font-display text-2xl text-[#2C4A3E] mt-4" data-testid="payment-not-confirmed">We couldn't confirm the payment yet</p><p className="text-stone-500 mt-2">If you were charged, it will appear shortly.</p></>}
      <Link to="/" className="inline-block mt-8 px-6 py-3 rounded-full bg-[#2C4A3E] text-white" data-testid="payment-home-btn">Go to my learning space</Link>
    </div>
  );
};

export const PaymentCancel = () => (
  <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
    <p className="font-display text-3xl text-[#2C4A3E]">Checkout canceled</p>
    <p className="text-stone-500 mt-2">No charge was made. You can subscribe anytime.</p>
    <Link to="/pricing" className="inline-block mt-8 px-6 py-3 rounded-full bg-[#2C4A3E] text-white" data-testid="payment-back-pricing-btn">Back to pricing</Link>
  </div>
);
